module.exports = __webpack_public_path__ + "static/media/pg31.6563fea1.jpg";